/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateContractEstimateItemDto
 */
export interface CreateUpdateContractEstimateItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractEstimateItemDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractEstimateItemDto
     */
    estimateItemId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractEstimateItemDto
     */
    contractId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractEstimateItemDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateContractEstimateItemDto interface.
 */
export function instanceOfCreateUpdateContractEstimateItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "estimateItemId" in value;
    isInstance = isInstance && "contractId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateContractEstimateItemDtoFromJSON(json: any): CreateUpdateContractEstimateItemDto {
    return CreateUpdateContractEstimateItemDtoFromJSONTyped(json, false);
}

export function CreateUpdateContractEstimateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateContractEstimateItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'estimateItemId': json['estimateItemId'],
        'contractId': json['contractId'],
        'active': json['active'],
    };
}

export function CreateUpdateContractEstimateItemDtoToJSON(value?: CreateUpdateContractEstimateItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'estimateItemId': value.estimateItemId,
        'contractId': value.contractId,
        'active': value.active,
    };
}

